import React from "react";
import { useQuery } from "@apollo/client";
import { SHOP } from "../../graphql/shop/queryShop";
import LoadingSpinner from "../../components/LoadingSpinner";
import PostFeed from "./PostFeed";
import PostFeedAllPosts from "./PostFeedAllPosts";

/**
 * /post-feed — which post screen this shop gets.
 *
 * ຮັບອໍເດີທຸກໂພສ ON: every post on the page, each with its own take-orders switch.
 * OFF (the default): the original PostFeed, untouched. The choice is the shop's setting, read
 * fresh so turning it on in Settings takes effect the next time this screen opens.
 */
const PostFeedGate = (props) => {
  const shopId = localStorage.getItem("SHOP");
  const { data, loading } = useQuery(SHOP, {
    variables: { where: { id: shopId } },
    skip: !shopId,
    fetchPolicy: "cache-and-network",
  });

  if (loading && !data) return <LoadingSpinner />;
  return data?.shop?.isCfAllPosts ? <PostFeedAllPosts {...props} /> : <PostFeed {...props} />;
};

export default PostFeedGate;
